import { DatePickerInput } from '@mantine/dates';
import dayjs from 'dayjs';
import 'dayjs/locale/id';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Field } from 'redux-form';
import { suspendFormPayload } from '../../../utils/builder/settingDataMerchant';
import Button from '../../elements/Button';
import Select from '../../fields/SelectBox';
import TextArea from '../../fields/TextArea';
import { fieldsProps } from './schema';
import styles from './styles.scoped.css';

export default function ApproveManualActivation({
  invalid,
  handleSubmit,
  handleClose,
  // initialValues = {}
}) {
  const { period, reason, dates } = fieldsProps;
  const { values } = useSelector((state) => state.form.formApproveManualActivation);
  const {
    data,
    response,
    isLoadingSubmissionProses
  } = useSelector((state) => state.manualLoggingActivation.dataSubmissionProses);
  const [startDate, setStartDate] = useState(dayjs().toDate());
  const [endDate, setEndDate] = useState(dayjs().add(7,'day').toDate());
  const showDateField = values.period.includes('Tertentu');

  const onSubmit = async (e) => {
    e.preventDefault();
    const payload = await suspendFormPayload({
      values: { ...values, startDate, endDate },
      withPeriod: showDateField,
    });
    handleSubmit(payload, data?.isReject ? 'reject' : 'approve');
  };

  const changeStartDate = (e) => {
    setStartDate(e);
    setEndDate(dayjs(e).add(7,'day').toDate());
  };

  return (
    <form
      className={styles.form}
      encType="multipart/form-data"
      onSubmit={onSubmit}
    >
      {response?.message && !response?.success ?
        <p className={styles.error}>{response?.message}</p> : null}
      {!data?.isReject ? (
        <Field
          component={Select}
          data={period.data}
          inputProps={period}
          name={period.name}
        />
      ) : null}
      {showDateField ? (
        <div className={styles.dates}>
          <DatePickerInput
            {...dates}
            minDate={new Date()}
            onChange={changeStartDate}
            value={startDate}
          />
          <span>sampai</span>
          <DatePickerInput
            {...dates}
            minDate={startDate}
            onChange={setEndDate}
            value={endDate}
            zIndex={1000}
          />
        </div>
      ) : null}

      {data?.isReject &&
        <Field
          component={TextArea}
          inputProps={{
            ...reason,
            label: data?.isReject && 'Alasan Tolak',
          }}
          name={reason.name}
        />
      }
      <div className={styles.actions}>
        <Button
          disabled={isLoadingSubmissionProses}
          onClick={handleClose}
          // style="default"
          outlined
          style="default"
          type="button"
        >
          Batal
        </Button>
        <Button
          disabled={invalid || isLoadingSubmissionProses}
          style={data?.isReject ? 'danger' : 'blue'}
          type="submit"
        >
          {data?.isReject ? 'Tolak' : 'Setujui'}
        </Button>
      </div>
    </form>
  );
}

ApproveManualActivation.propTypes = {
  handleClose: PropTypes.func,
  handleSubmit: PropTypes.func,
  initialValues: PropTypes.object,
  invalid: PropTypes.bool,
};
